export default {
  accountId: null,
  activeQuestionSet: {},
  activeView: 'mainEditor',
  comparisonQuestionSet: {},
  comparisonQuestionSetData: {},
  documents: [],
  expandedPages: {},
  expandedQuestions: {},
  insurers: [],
  isAppLoading: true,
  isDocumentsLoading: true,
  isEditorLoading: false,
  isInsurersLoading: true,
  isLookupsLoading: true,
  isPublishing: false,
  isQuestionSetsLoading: true,
  isSaving: false,
  isSchemeDirty: false,
  isSourceEditorDirty: false,
  lookups: [],
  masterAccountId: null,
  pageTriggers: [],
  questionPages: [],
  questionSetId: null,
  questionSets: [],
  riskGroups: [],
  schemeId: null,
  schemeName: '',
  searchTerm: '',
  selectedPage: '',
  sourceEditorJson: {},
  sourceEditorJsonError: false,
  sourceEditorValidationErrors: {},
};
